import { camelCase } from 'lodash';
import { EndpointData } from '../types/EndpointData';
import { CellValueGroup } from '../types/CellValueGroup';

enum EndpointType {
  'REST_API' = 'REST API',
  'EVENT_MESSAGING' = 'Event Messaging'
}

export interface EndpointCsvData {
  domain: CellValueGroup;
  process?: CellValueGroup;
  description: string;
  service: string;
  type: EndpointType;
  endpointName?: string;
  method?: string;
  numberOfConsumer?: number;
  platform?: string;
  goLiveYear?: string;
  consumer?: string;
  consumptionVolumeYtd?: string;
}

interface EndpointsRowData extends Omit<EndpointCsvData, 'consumer' | 'consumptionVolumeYtd'> {
  consumer?: string[];
  consumptionVolumeYtd?: string[];
}

export const getCsvData = (data: EndpointData[]): EndpointCsvData[] => {
  const convertedData: EndpointsRowData[] = data
    .map((domain) =>
      domain.rows.map((row) => {
        const columns = row.columns.reduce(
          (previousColumn, currentColumn) => ({
            ...previousColumn,
            [camelCase(currentColumn.columnName as string)]: currentColumn.columnValue
          }),
          {}
        );
        return {
          domain: domain.groupedColumnValue,
          process: domain.groupedColumnAdditionalValue,
          ...columns
        } as EndpointsRowData;
      })
    )
    .flat();

  const splitTheConsumerToDifferentRow = (row: EndpointsRowData): EndpointCsvData[] => {
    const tempResult = [];
    if (!row.consumer) {
      return [{ ...row, consumer: '-', consumptionVolumeYtd: '-' }];
    }
    for (let i = 0; i < row.consumer.length; i += 1) {
      tempResult.push({
        ...row,
        consumer: row?.consumer ? row?.consumer[i] : undefined,
        consumptionVolumeYtd: row?.consumptionVolumeYtd ? row?.consumptionVolumeYtd[i] : undefined
      });
    }
    return tempResult;
  };

  return convertedData.map(splitTheConsumerToDifferentRow).flat();
};
